import { Guides } from '@starflow/app/components/navbar';

export default {
  setup({ app }) {
    app.extension.registerComponent('navbar_left', { Component: Guides });
  },
};
